import { BaseEntityDto } from '@fleet-beat/core';

export interface ExternalApiKey {
  name?: string;
  isActive: boolean;
  companyId?: string;
}

export interface ExternalCompanyApiKey extends BaseEntityDto {
  companyId: string;
  id: string;
  key: string;
  name: string;
}
